import { render, staticRenderFns } from "./fee-pdf-page.vue?vue&type=template&id=8d477ad4&"
import script from "./fee-pdf-page.vue?vue&type=script&lang=ts&"
export * from "./fee-pdf-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports